import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GlobalExperienceState, Game } from '../common-types/GlobalExperienceState.type';
import { SiteExperienceConfiguration } from '../common-types/ScreensConfigurations.type';

const initialState: GlobalExperienceState = {
  games: [],
  siteExperienceConfiguration: null,
  thumbnails: [],
};

export const globalExperienceSlice = createSlice({
  initialState,
  name: 'GlobalExperience',
  reducers: {
    setInitialExperienceData (
      state: GlobalExperienceState,
      { payload }: PayloadAction<{ siteConfiguration: SiteExperienceConfiguration, games: Game[] }>
    ): GlobalExperienceState {
      const thumbnails = payload.games
        .filter((game) => game.thumbnailUrl !== null)
        .map((game) => ({ campId: game.ticket.code, url: game.thumbnailUrl as string }));
      return {
        ...state,
        games: payload.games,
        siteExperienceConfiguration: payload.siteConfiguration,
        thumbnails,
      };
    },
  },
});

const { actions, reducer } = globalExperienceSlice;

export const { setInitialExperienceData } = actions;
export default reducer;
